import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment-duration-format';
import {decimaltoHex, RGBFormatFromDecimal} from '../../../../utilities/common';
import {isEmpty} from '../../../../utilities/validation';

const getDataFromNode = function(node) {
    const nodeDict = ['id', 'title', 'x', 'y', 'text_align', 'selectable', 'visible', 'width', 'height',
        'fontsize', 'fontcolor', 'bgcolor', 'bgalpha'].reduce((data, key) => {
        return { ...data, [key]: node.attr[key] };}, { val: node.val });
    return nodeDict;
};


class TimerLabelNode extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...getDataFromNode(props.node),
        };
    }

    formatCurrentSecondsString() {
        //var seconds = parseInt(this.props.currentSeconds);
        return moment.duration(this.props.currentSeconds, 'seconds').format('m:ss', { trim: false });
    }

    render() {
        const {x= 0, y=0, width=0, height=0, visible=false, text_align='center', fontcolor, fontsize,
            bgcolor, bgalpha} = this.state;

        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            height: `${height}px`,
            width: `${width}px`,
            textAlign: text_align,
            userSelect: 'none',
            display: visible ? 'block' : 'none',
            color: fontcolor ? `#${decimaltoHex(fontcolor)}` : 'inherit',
            fontSize: fontsize ? `${fontsize}px` : 'inherit',
            backgroundColor: !isEmpty(bgcolor) ? RGBFormatFromDecimal(bgcolor, bgalpha) : 'transparent',
        };

        return (
            <div className="node timer-label-node" style={divStyle}>
                {this.formatCurrentSecondsString()}
            </div>
        );

    }
}



TimerLabelNode.propTypes = {
    node: PropTypes.object.isRequired,
    currentSeconds: PropTypes.number.isRequired,
};


export default TimerLabelNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/timer-label-node.js